import { PageLink } from '../../../../../../../assets/layout/core'

export const breadcrumbView: PageLink[] = [
  {
    title: 'Usuários',
    path: '/users',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
